export interface SearchOptions {
  key: string;
  typeahead?: boolean;
  limit?: number;
  ofs?: number;
  countrySet?: string;
  lat?: number;
  lon?: number;
  radius?: number;
  topLeft?: string;
  btmRight?: string;
  language?: string;
  extendedPostalCodesFor?: string;
  minFuzzyLevel?: number;
  maxFuzzyLevel?: number;
  idxSet?: string;
  categorySet?: string;
  brandSet?: string;
  connectorSet?: string;
  view?: string;
  openingHours?: string;
  timeZone?: string;
  mapcodes?: string;
}

export interface SearchResult {
  summary: any;
  results: any[];
}

/**
 * Fuzzy search
 * https://developer.tomtom.com/search-api/search-api-documentation-search/fuzzy-search
 */
export const fuzzySearch = async (query: string, options: SearchOptions): Promise<SearchResult> => {
  if (query === "") {
    return { summary: { query }, results: [] };
  }
  const searchParams = new URLSearchParams(options as Record<string, any>).toString();
  const URL = `https://api.tomtom.com/search/2/search/${encodeURIComponent(
    query
  )}.json?${searchParams}`;
  const response = await fetch(URL);
  const content = await response.json();

  return content;
};
